<template>
  <section id="vendors"  class="vendor-logos">
    <b-container>
      <b-row class="py-5 px-4">
        <b-col cols="6" sm="3" lg="2" class="m-auto" v-for="vendor in vendors" :key="vendor">
          <b-img-lazy offset="400" :src="require(`@/assets/logos/${vendor}`)" fluid></b-img-lazy>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "vendors",
  data() {
    return {
      vendors: ["anderson.png", "dupont.png", "hybrid.png", "luscher.png"]
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/custom';

.vendor-logos {
  border-top: 3px solid $primary;
  background-color: $accent;
  min-height: 150px;
}

</style>